import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {
 
    },
    actions: {
        fetchVendu(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/vehicules/vendu', { params: payload })
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
            })
        },
        
    },
}
